module.exports = __webpack_public_path__ + "img/6.56fb3623.png";